import React from "react";
import { useStateContext } from "../../contexts/ContextProvider";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import moment from "moment";

import Select from "react-select";

import { Form } from "react-bootstrap";

const GrievancesFilterModal = ({
  status,
  setStatus,
  applyFilter,
  resetFilter,
  validated,
  details,
  setDetails,
  issueTypes,
  formdate,
  setFormdate
}) => {
  const { filterBy } = useStateContext();

  const handleChange = (e) => {
    setFormdate(e.value);
    setDetails({
      ...details,
      date: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  const handleSelect = (e) => {
    setDetails({ ...details, issueType: e });
  };

  return (
    <>
      <div
        className={`${
          filterBy ? "filterByModal visible" : "filterByModal hidden"
        }`}
      >
        <div className="filter-flex">
          <Form noValidate validated={validated} onSubmit={applyFilter}>
            <div className="sort-list">
              <div className="heading mb-3">
                <span>Filter</span>
              </div>
              <div className="mb-3">
                <label htmlFor="leaveType" className="form-label">
                  Issue Type
                </label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      height: "45px",
                      fontSize: "16px",
                      lineHeight: "20px",
                      fontWeight: "500",
                      border: "1px solid rgba(210, 205, 218, 1)",
                    }),
                    option: (baseStyles, { isFocused, isSelected }) => ({
                      ...baseStyles,
                      fontSize: "16px",
                      lineHeight: "20px",
                      fontWeight: "500",
                      borderRadius: "4px",
                      backgroundColor: isSelected
                        ? "rgba(177, 206, 251, 1)"
                        : isFocused
                        ? "rgba(177, 206, 251, 1)"
                        : "rgba(255, 255, 255, 1)",
                      color: isSelected
                        ? "rgba(78, 70, 94, 1)"
                        : isFocused
                        ? "rgba(78, 70, 94, 1)"
                        : "rgba(78, 70, 94, 1)",
                    }),
                    menu: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                    }),
                  }}
                  options={issueTypes}
                  onChange={handleSelect}
                  value={details?.issueType}
                />
              </div>
              <div className="mb-3 calendar-relative">
                <label htmlFor="leaveType" className="form-label">
                  Date
                </label>
                <Calendar
                  value={formdate}
                  onChange={handleChange}
                  view="date"
                  dateFormat="dd, MM, yy"
                  style={{ width: "100%", height: "45px" }}
                  showIcon
                  selectOtherMonths
                />
              </div>
            </div>
            <div className="sort-action">
              <button className="btn btn-reset" onClick={resetFilter}>
                Reset
              </button>
              <button className="btn btn-apply">Apply</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default GrievancesFilterModal;
